<template>
  <v-footer padless class="custom-footer white">
    <v-card flat tile width="100%" class="footer-content white">
      <v-row no-gutters justify="center" align-content="center">
        <v-col v-for="(elem, i) in content" :key="i" cols="12" sm="4" md="3">
          <FooterCard
            :image="elem.image"
            :title="elem.title"
            :text="elem.text"
            :links="elem.links"
          />
        </v-col>
        <v-spacer />
      </v-row>
    </v-card>
    <v-card flat tile width="100%" class="white">
      <div class="powered-by">
        Copyright © 2020 foncierpublic.com. Conçu par
        <a target="_blank" href="https://www.cristal.je/">Cristal</a>.
      </div>
    </v-card>
  </v-footer>
</template>

<style scoped>
.custom-footer {
  background: transparent;
}

.footer-content {
  margin: 0px 20px;
  padding: 30px 0px;
}

.powered-by {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #627d98;
  padding-left: 4em;
  height: 40px;
}
</style>

<script>
import jsonLoader from "@/services/jsonParser";
import FooterCard from "@/components/Footer/FooterCard";

export default {
  name: "Footer",
  components: { FooterCard },
  data: () => ({
    content: null,
  }),
  beforeMount() {
    jsonLoader("footer").then((data) => {
      this.content = data;
    });
  },
};
</script>
